import React, { useEffect, useState } from 'react';
import Layout from '../../components/shared/Layout';
import { Card, PageHeader, Button, Input, Badge } from '../../components/shared/ui';
import { studentAPI } from '../../utils/api';

const PLATFORMS = ['Hack The Box','TryHackMe','PicoCTF','HackerOne','Bugcrowd','Intigriti','CTFtime'];
const PROJECT_TYPES = ['CTF Writeup','Bug Bounty','Araç Geliştirme','Güvenlik Araştırması','Makale','Diğer'];
const emptyProject = { title:'', type:'CTF Writeup', description:'', url:'', date:'' };

const Field = ({ label, children }) => (
  <div><label className="block text-sm font-medium text-ink-700 mb-1">{label}</label>{children}</div>
);

const Portfolio = () => {
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [ctf, setCtf] = useState({});
  const [projects, setProjects] = useState([]);
  const [profileProjects, setProfileProjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyProject);

  useEffect(() => {
    studentAPI.getProfile().then(r => {
      setProfile(r.data);
      setCtf(r.data.ctf_platforms || {});
      setProjects(Array.isArray(r.data.portfolio) ? r.data.portfolio : []);
      setProfileProjects(Array.isArray(r.data.projects) ? r.data.projects : []);
    });
  }, []);

  const addProject = () => {
    if (!form.title) return;
    setProjects(p => [{ ...form, id: Date.now() }, ...p]);
    setForm(emptyProject); setShowForm(false);
  };
  const removeProject = (id) => setProjects(p => p.filter(x => x.id !== id));
  const handleSave = async () => {
    setSaving(true);
    try { await studentAPI.updateProfile({ ...profile, portfolio: projects, ctf_platforms: ctf }); setSaved(true); setTimeout(() => setSaved(false), 3000); }
    finally { setSaving(false); }
  };

  if (!profile) return <Layout><p className="text-ink-500">Yükleniyor...</p></Layout>;

  return (
    <Layout>
      <PageHeader
        title="Portföy"
        description="CTF deneyimleri, bug bounty bulguları, projeler"
        actions={<Button onClick={handleSave} disabled={saving}>{saved ? '✓ Kaydedildi' : saving ? 'Kaydediliyor...' : 'Kaydet'}</Button>}
      />

      <div className="max-w-3xl space-y-5">
        <Card>
          <h2 className="text-base font-semibold text-ink-900 mb-2">Platform Profilleri</h2>
          <p className="text-sm text-ink-500 mb-4">HackTheBox rank, TryHackMe puan, bug bounty profil linklerini gir</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {PLATFORMS.map(p => (
              <Input key={p} label={p} placeholder={`${p} profil linki veya kullanıcı adı`}
                value={ctf[p] || ''} onChange={e => setCtf(c => ({ ...c, [p]: e.target.value }))} />
            ))}
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-semibold text-ink-900">Projeler & Writeuplar</h2>
            <Button variant={showForm ? 'secondary' : 'primary'} onClick={() => setShowForm(s => !s)}>
              {showForm ? 'İptal' : '+ Ekle'}
            </Button>
          </div>

          {showForm && (
            <div className="bg-ink-50 rounded-xl p-4 mb-5 border border-ink-200">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                <div className="sm:col-span-2">
                  <Input label="Başlık *" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
                    placeholder="örn: HackTheBox — Lame Writeup" />
                </div>
                <Field label="Tür">
                  <select className="input" value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}>
                    {PROJECT_TYPES.map(t => <option key={t}>{t}</option>)}
                  </select>
                </Field>
                <Input label="Tarih" type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} />
                <div className="sm:col-span-2">
                  <Field label="Açıklama">
                    <textarea rows={3} className="input resize-y" value={form.description}
                      onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                      placeholder="Neler öğrendin, hangi teknikleri kullandın?" />
                  </Field>
                </div>
                <div className="sm:col-span-2">
                  <Input label="Link (opsiyonel)" value={form.url} onChange={e => setForm(f => ({ ...f, url: e.target.value }))}
                    placeholder="https://github.com/... veya writeup linki" />
                </div>
              </div>
              <Button onClick={addProject} disabled={!form.title}>Ekle</Button>
            </div>
          )}

          {profileProjects.length > 0 && (
            <div className="mb-5">
              <div className="text-xs font-semibold text-ink-500 uppercase tracking-wide mb-2">Profilden Aktarılan Projeler</div>
              <div className="space-y-2">
                {profileProjects.map((pp, i) => (
                  <div key={'pp-'+i} className="border border-brand-200 bg-brand-50/30 rounded-xl p-3 sm:p-4">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="font-semibold text-sm text-ink-900">{pp.name || pp.title || '—'}</span>
                      {pp.type && <Badge tone="violet">{pp.type}</Badge>}
                      {pp.date && <span className="text-xs text-ink-400">{pp.date}</span>}
                    </div>
                    {pp.description && <p className="text-sm text-ink-600 mt-1">{pp.description}</p>}
                    {pp.technologies && <p className="text-xs text-ink-500 mt-1">Teknolojiler: {pp.technologies}</p>}
                    <div className="flex flex-wrap gap-3 mt-2">
                      {pp.github_url && <a href={pp.github_url} target="_blank" rel="noreferrer" className="text-xs text-brand-700 hover:text-brand-800 break-all">GitHub →</a>}
                      {pp.demo_url && <a href={pp.demo_url} target="_blank" rel="noreferrer" className="text-xs text-brand-700 hover:text-brand-800 break-all">Demo →</a>}
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-[11px] text-ink-400 mt-2">Düzenlemek için Profil → Projeler bölümüne git</p>
            </div>
          )}

          {projects.length === 0 && profileProjects.length === 0 && !showForm && (
            <p className="text-ink-400 text-sm text-center py-6">
              Henüz proje eklenmedi. CTF writeuplarını, bug bounty bulgularını veya araçlarını ekle.
            </p>
          )}

          <div className="space-y-2">
            {projects.map(p => (
              <div key={p.id} className="border border-ink-200 rounded-xl p-3 sm:p-4 flex justify-between items-start gap-2">
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="font-semibold text-sm text-ink-900">{p.title}</span>
                    <Badge tone="blue">{p.type}</Badge>
                    {p.date && <span className="text-xs text-ink-400">{new Date(p.date).toLocaleDateString('tr-TR')}</span>}
                  </div>
                  {p.description && <p className="text-sm text-ink-600 mt-1">{p.description}</p>}
                  {p.url && <a href={p.url} target="_blank" rel="noreferrer" className="text-xs text-brand-700 hover:text-brand-800 break-all">{p.url}</a>}
                </div>
                <button onClick={() => removeProject(p.id)} className="text-ink-400 hover:text-red-600 text-xl leading-none px-1">×</button>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default Portfolio;
